import {
  getRelativeFontSize,
  mediumFont,
  regularFont,
} from "../../../../utils/styles";

const promoCodeDialogStyles = {
  lightTypo: {
    ...regularFont,
    fontSize: getRelativeFontSize(1),
    color: "rgba(34, 34, 34, 0.70)",
  },
  loginBtn: {
    py: 1.5,
    borderRadius: "8px",
    background: "#9053F6",
    minWidth: "180px",
    textShadow: "0 1px 0 rgb(0 0 0 / 40%)",
    transition: "box-shadow 0.15s ease, transform 0.15s ease",
    willChange: "box-shadow,transform",

    "&:hover": {
      boxShadow:
        "0px 0.1em 0.2em rgb(45 35 66 / 40%), 0px 0.4em 0.7em -0.1em rgb(45 35 66 / 30%), inset 0px -3px 0px #FDFDFD",
      transform: "translateY(-0.1em)",
      background: "#9053F6",
      color: "#FDFDFD",
    },
    "&:disabled": {
      background: "#c09aff",
    },
  },
  loginBtnTypo: {
    color: "#FDFDFD",
    ...mediumFont,
    fontSize: getRelativeFontSize(8),
  },
  promoTextField: {
    width: "100%",
    borderRadius: "8px",
    border: "none",
    background: "#F0F0F0",
    backdropFilter: "blur(5.5px)",

    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#F0F0F0",
    },
    "& .MuiOutlinedInput-notchedOutline:hover": {
      borderColor: "#F0F0F0",
    },

    "& .MuiInputBase-input": {
      position: "relative",
      padding: "8px 8px",
      color: "#9053F6",
      textAlign: "center",
      fontSize: getRelativeFontSize(12),
      ...mediumFont,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      borderColor: "#F0F0F0",
      "&.Mui-focused fieldset": {
        borderColor: "#F0F0F0",
      },
    },
  },
  errorStyling: {
    ...regularFont,
    fontSize: getRelativeFontSize(1),
    paddingLeft: "10px",
  },
  dialogContent: {
    margin: "0 5%",
  },
} as const;

export default promoCodeDialogStyles;
